export const getTokenData = () => {
  const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
  return {
    token: storage_session['token'],
    idname: storage_session['idname'],
  };
};

// Reference line for 70%
export const referenceLine = {
  type: 'line',
  color: '#fff',
  dataPoints: [
    {
      x: -15,

      y: 100,
    },
    {
      x: 20,

      y: 100,
    },
    {
      x: 20,

      y: 100,
    },
  ],
  markerType: 'none',
};
// 20% line
export const twentyPercentLine = {
  showInLegend: false,
  name: '20%',
  type: 'line',
  lineDashType: 'dash',
  color: '#39c089',
  markerType: 'none',
};
//80% line
export const eightyPercentLine = {
  showInLegend: false,
  name: '80%',
  type: 'line',
  lineDashType: 'dot',
  color: '#1d364b',
  markerType: 'none',
};

export const getLabelAngleWithFontSize = (w) => {
  let labelAngle = 0;
  let labelFontSize = 0;
  if (w > 1200) {
    labelAngle = 0;
    labelFontSize = 15;
  } else if (w > 991 && w < 1200) {
    labelAngle = -20;
    labelFontSize = 12;
  } else if (w > 767 && w < 991) {
    labelAngle = 90;
    labelFontSize = 15;
  } else {
    labelAngle = -90;
    labelFontSize = 12;
  }
  return {
    labelAngle,
    labelFontSize,
  };
};



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/ResultGraph/graphConstants.js